import React, { useEffect, useRef } from 'react'
import { setFocus } from '@noriginmedia/norigin-spatial-navigation'

import Platform from '../../platforms'
import tts from '../../lib/TTS'
import FocusableButtonTS from '../FocusableButton/FocusableButtonTS'

import type { UrgentMessageModalProps } from './types'
import { useSidePanel } from '../SidePanel/SidePanelProvider'
import googleAnalytics4 from '../../lib/googleAnalytics'

const URGENT_MESSAGE_MODAL_CLOSE_BTN = 'URGENT_MESSAGE_MODAL_CLOSE_BTN'

const UrgentMessageModal = ({ onCloseModal }: UrgentMessageModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null)
  const { setForceSidePanelOpenedUnfocused } = useSidePanel()

  const toggleBlur = (toggleAction) => {
    const sidePanelLayout = document.getElementById(
      'side-panel-layout'
    ) as HTMLElement
    if (sidePanelLayout) {
      sidePanelLayout.style.filter = toggleAction ? 'blur(10px)' : 'none'
    }
  }

  const readMessageContent = () => {
    const { headerText, descriptionText, urlHeaderText, displayUrl } =
      Platform.urgentMessage.details
    tts.addTextToRead(
      `${headerText} ...  ${descriptionText} ... ${urlHeaderText} .... ${displayUrl
        .split('.')
        .join(' dot ')} .... Focussed on Dismiss Button`
    )
  }

  useEffect(() => {
    tts.stopRead()
    //backdrop-filter isnt supported on the devices.
    toggleBlur(true)
    readMessageContent()
    sendUrgentMessageEvent()
    setTimeout(() => setFocus(URGENT_MESSAGE_MODAL_CLOSE_BTN), 100)
    setForceSidePanelOpenedUnfocused(true)
    return () => {
      setForceSidePanelOpenedUnfocused(false)
      setFocus(null)
    }
  }, [])

  const sendUrgentMessageEvent = () => {
    googleAnalytics4.sendCustomEvent('feature_tracking', {
      feature_category: 'urgent messaging',
      feature_name: 'modal',
      object_name: 'modal',
      object_action: 'impression',
      object_action_behavior: 'display content',
    })
  }

  const handleEnterPress = () => {
    tts.pushTextToRead('Message dismissed')
    toggleBlur(false)
    onCloseModal()
  }

  const messageData = Platform.urgentMessage.details
  const headerText = messageData.headerText.replace(/:/g, ':\n')

  return (
    <div className="urgent-message-modal" ref={modalRef}>
      <div className="urgent-message-modal__popup">
        <div className="urgent-message-modal__header">
          <p className="urgent-message-modal__header-text">{headerText}</p>
          <p className="urgent-message-modal__description-text">
            {messageData.descriptionText}
          </p>
        </div>
        <div className="urgent-message-modal__body">
          <p className="urgent-message-modal__url-header-text">
            {messageData.urlHeaderText}
          </p>
          <p className="urgent-message-modal__display-url">
            {messageData.displayUrl}
          </p>
          <img
            className="urgent-message-modal__image"
            src={messageData.qrCodeImageUrl}
            alt="QR Code"
          />
        </div>
        <div className="urgent-message-modal__footer">
          <FocusableButtonTS
            className="urgent-message-modal__close-button"
            onEnterPress={handleEnterPress}
            focusKey={URGENT_MESSAGE_MODAL_CLOSE_BTN}
            onFocus={readMessageContent}
          >
            <span className="urgent-message-modal__close-button--text">
              Dismiss
            </span>
          </FocusableButtonTS>
        </div>
      </div>
    </div>
  )
}

export default UrgentMessageModal
